import map from 'lodash/map';
import range from 'lodash/range';

const countMapping = {
  daily: 14,
  weekly: 14,
  monthly: 14,
};

const buildOptions = ({ count }) => map(range(1, count + 1), (index) => ({
  id: index,
  value: index,
  label: String(index),
}));

export default ({ frequency }) => buildOptions({ count: countMapping[frequency] });
